import axios from 'axios'

export const apiResource = axios.create({
  headers: { Pragma: 'no-cache' },
  baseURL: process.env.VUE_APP_API_URL,
  crossDomain: true
})
